import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { Typography, Button, Input } from "@atoms";
import { theme } from "@theme";
import { Container } from "./recovery.styles";
import { axiosInstance } from "utils";
import { Form } from "antd";
import { Wrapper } from "../Login/login.styles";

function Recovery() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isError) {
      form.setFields([
        {
          name: "email",
          errors: [t("accNotFound")],
        },
      ]);
    }
  }, [isError]);

  const handleClick = async () => {
    setIsError(false);
    setIsLoading(true);
    try {
      await axiosInstance.post("/accounts/send-reset-password-link/", {
        login: email.toLowerCase(),
      });

      navigate("/recovery-check-email");
    } catch (error) {
      // @ts-ignore
      const err = error?.response?.data?.detail === "Пользователь не найден";
      setIsError(err);
      !err &&
        toast.error(t("somethingerr"), {
          position: "bottom-right",
          theme: "colored",
        });
    } finally {
      setIsLoading(false);
    }
  };

  const handleValuesChange = async () => {
    form
      .validateFields()
      .then((res) => {
        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(!!err.errorFields.length);
      });
  };

  return (
    <Wrapper>
      <Container>
        <Typography as="h2">{t("recovery")}</Typography>
        <Typography
          as="label"
          style={{
            color: "rgba(6, 6, 6, 0.8)",
            textAlign: "center",
            marginTop: "-8px",
          }}
        >
          {t("writeEmail1pt")} <br /> {t("writeEmail2pt")}
        </Typography>
        <Form
          style={{ width: "100%" }}
          form={form}
          layout="vertical"
          onValuesChange={handleValuesChange}
          requiredMark={false}
        >
          <Form.Item
            label="Email"
            name="email"
            // style={{ margin: 0 }}
            rules={[
              { required: true, message: t("writeEmail") },
              {
                type: "email",
                message: t("emailError"),
              },
            ]}
          >
            <Input
              name="email"
              form={form}
              value={email}
              onChange={setEmail}
              placeholder={t("writeEmail")}
            />
          </Form.Item>
        </Form>

        <Button
          variant="primary"
          size="large"
          fullWidth
          disabled={isDisabled}
          loading={isLoading}
          onClick={handleClick}
        >
          <Typography style={{ color: theme.palette.default }}>
            {t("continue")}
          </Typography>
        </Button>

        <Button
          variant="outlined"
          size="large"
          fullWidth
          onClick={() => navigate("/")}
          style={{ marginTop: "-8px" }}
        >
          <Typography style={{ color: "inherit" }}>
            Вернуться на главную
          </Typography>
        </Button>
      </Container>
    </Wrapper>
  );
}

Recovery.CheckRecovery = () => {
  return (
    <Wrapper>
      <Container>
        <Typography as="h2">Проверьте вашу почту</Typography>
        <Typography
          as="label"
          style={{
            color: "rgba(6, 6, 6, 0.8)",
            textAlign: "center",
            marginTop: "-8px",
          }}
        >
          Мы отправили письмо на почту для сброса парола
        </Typography>

        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={() => (window.location.href = "mailto:")}
        >
          <Typography style={{ color: theme.palette.default }}>
            Открыть приложение почта
          </Typography>
        </Button>
        <Button
          variant="outlined"
          size="large"
          fullWidth
          onClick={() => (window.location.href = "/")}
          style={{ marginTop: "-8px" }}
        >
          <Typography style={{ color: "inherit" }}>
            Вернуться на главную
          </Typography>
        </Button>
      </Container>
    </Wrapper>
  );
};

export default Recovery;
